/**
 * DocumentSet selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

import { AppState } from 'services/types';
import { DocumentSet } from './types';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectDocumentSets = (state: AppState) => state.documentSets;

const selectDocumentSetId = (
    state: AppState,
    { documentSetId }: { documentSetId: number }
) => documentSetId;

const selectDocumentSetsArray = createDeepEqualSelector(
    selectDocumentSets,
    (documentSetsState) => Object.values(documentSetsState)
);

const selectDocumentSet = createDeepEqualSelector(
    [selectDocumentSets, selectDocumentSetId],
    (documentSetsState, documentSetIdState) =>
        documentSetsState[documentSetIdState]
);

const selectDocumentSetExists = createDeepEqualSelector(
    selectDocumentSet,
    (documentSetState): boolean => !!documentSetState
);

const makeSelectDocumentSetExists = (): typeof selectDocumentSetExists =>
    selectDocumentSetExists;

const makeSelectDocumentSetValue = <T extends keyof DocumentSet>(field: T) =>
    createDeepEqualSelector(
        selectDocumentSet,
        (documentSet): DocumentSet[T] => documentSet && documentSet[field]
    );

export {
    selectDocumentSets,
    selectDocumentSetId,
    selectDocumentSetsArray,
    selectDocumentSet,
    makeSelectDocumentSetExists,
    makeSelectDocumentSetValue
};
